import { render, staticRenderFns } from "./orderAdd.vue?vue&type=template&id=4f5026d2&scoped=true"
import script from "./orderAdd.vue?vue&type=script&lang=js"
export * from "./orderAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f5026d2",
  null
  
)

export default component.exports